import React from "react";
import LocationOnIcon from '@mui/icons-material/LocationOn'; 
import DomainIcon from '@mui/icons-material/Domain';
import WeekendIcon from '@mui/icons-material/Weekend';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import PersonIcon from '@mui/icons-material/Person';
import { Paper, Typography, Divider, Box } from '@mui/material';

export default function BienInfoSection({ bien }) {
  if (!bien) return null;
  const sci = bien.sci || {};
  const syndic = bien.syndic || null;
  return (
    <Paper sx={{ my: 2, p: { xs: 2, sm: 4 }, mx: "auto", maxWidth: 800 }}>
        <Box sx={{ maxWidth: 750, mx: "auto" }}>
            <Box
                sx={{
                    width: "100%",
                    mb: 2,
                    p: 2,
                    background: "#f4f6fa",
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {bien.meuble ? (
                    <>
                    <WeekendIcon color="primary" sx={{ fontSize: 32, mr: 2 }} />
                    <Typography variant="h6" fontWeight={700}>
                        Bien Meublé
                    </Typography>
                    </>
                ) : (
                    <>
                    <HomeWorkIcon color="primary" sx={{ fontSize: 32, mr: 2 }} />
                    <Typography variant="h6" fontWeight={700}>
                        Bien Nu
                    </Typography>
                    </>
                )}
            </Box>

            <Box mb={5} />

            <Box
            sx={{
                width: "100%",
                background: "#fff",
                borderRadius: 1,
                p: 2,
                mb: 2,
                display: { xs: "block", sm: "flex" },
                gap: 3,
            }}
            >
            <Box display="flex" alignItems="flex-start" flex={1}>
                <LocationOnIcon color="primary" sx={{ mr: 1, mt: "4px" }} />
                <Box>
                <Typography><b>Adresse :</b></Typography>
                <Typography>{bien.adresse}</Typography>
                <Typography>
                    {bien.code_postal} {bien.ville}
                </Typography>
                </Box>
            </Box>
            <Box display="flex" alignItems="flex-start" flex={1}>
                <DomainIcon color="action" sx={{ mr: 1, mt: "4px" }} />
                <Box>
                <Typography><b>SCI Propriétaire :</b></Typography>
                <Typography>
                    {sci.raison_sociale || <span style={{ color: "#aaa" }}>Non renseigné</span>}
                </Typography>
                {sci.adresse && (
                    <>
                        <Typography>{sci.adresse}</Typography>
                        <Typography>{sci.code_postal} {sci.ville}</Typography>
                    </>     
                )}
                </Box>
            </Box>
            </Box>

            <Box mb={5} />
            
            {!!syndic && (
            <Box
                sx={{
                width: "100%",
                background: "#f4f6fa",
                borderRadius: 1,
                p: 2,
                display: { xs: "block", sm: "flex" },
                gap: 3,
                }}
            >
                <Box display="flex" alignItems="flex-start" flex={1}>
                <DomainIcon color="action" sx={{ mr: 1, mt: "4px" }} />
                    <Box>
                        <Typography fontWeight={700} sx={{ mb: 0.5 }}>Syndic de copropriété</Typography>
                        <Typography fontWeight={500} sx={{ mb: 0.5 }}>{syndic.nom}</Typography>
                        <Typography>{syndic.adresse}</Typography>
                        <Typography>{syndic.code_postal} {syndic.ville}</Typography>
                    </Box>
                </Box>
                <Divider
                flexItem
                sx={{
                    mx: { xs: 0, sm: 2 },
                    my: { xs: 2, sm: 0 },
                    borderColor: "#cdd1d7",
                    display: { xs: "none", sm: "block" }
                }}
                orientation="vertical"
                />
                <Box display="flex" alignItems="flex-start" flex={1}>
                <PersonIcon color="secondary" sx={{ mr: 1, mt: "2px" }} />
                    <Box>
                        <Typography fontWeight={700} sx={{ mb: 0.5 }}>Gestionnaire</Typography>
                        {(syndic.gestionnaire_prenom || syndic.gestionnaire_nom) ? (
                        <>
                            <Typography sx={{ mb: 0.5 }}>
                            {syndic.gestionnaire_prenom} {syndic.gestionnaire_nom}
                            </Typography>
                            {syndic.gestionnaire_telephone && (
                            <Typography color="text.secondary" variant="body2">
                                Tél : {syndic.gestionnaire_telephone}
                            </Typography>
                            )}
                            {syndic.gestionnaire_email && (
                            <Typography color="text.secondary" variant="body2">
                                Email : {syndic.gestionnaire_email}
                            </Typography>
                            )}
                        </>
                        ) : (
                        <Typography sx={{ color: "#aaa" }}>Non renseigné</Typography>
                        )}
                    </Box>
                </Box>
            </Box>
            )}
        </Box>
    </Paper>
  );
}